import React from 'react'
import { connect } from 'react-redux'
import styled from 'styled-components'

import rectangle from "./Rectangle.png"

const Wrapper = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-content: stretch;
    justify-content: space-around;
    align-items: center;
`

export const Safety = (props) => {
    return (
        <div>
            <h1 style={{ textAlign: 'center' }}>ИНСТРУКЦИЯ ПО ОХРАНЕ ТРУДА ПРИ ПРОВЕДЕНИИ ЗАНЯТИЙ В КОМПЬЮТЕРНОМ КЛАССЕ</h1>
            <Wrapper>
                <div>
                    <h2>Общие требования охраны труда.</h2>
                    <div style={{display: 'flex', flexDirection: 'row', flexWrap: 'wrap', justifyContent: 'space-around', alignItems: 'flex-start'}}>
                        <ul style={{maxWidth:450, display: "inline-block"}}>
                            <li>К занятиям в компьютерном классе допускаются только учащиеся, прошедшие инструктаж о мерах безопасности при работе с находящимся в кабинете оборудованием и ознакомившиеся с настоящей инструкцией.</li>
                            <li>Работа в компьютерном классе проводится только в присутствии учителя, под его руководством и постоянным наблюдением. Запрещается входить в компьютерный класс без разрешения педагога.</li>
                            <li>Требования инструкции являются обязательными для учащихся, невыполнение этих требований рассматривается как нарушение трудовой и учебной дисциплины.</li>
                            <li>Настоящая инструкция должна быть вывешена на специальном стенде в компьютерном классе.</li>
                            <li>Опасные и вредные производственные факторы: <br />
                                - воздействие на организм человека ионизирующего и неионизирующего излучений видеотерминалов;<br />
                                - поражение электрическим током при работе на оборудовании без защитного заземления, со снятой задней крышкой видеотерминала, при отсутствии защитного экрана блока строчной развертки;<br />
                                - неблагоприятное воздействие на зрение при неустойчивой работе видеотерминалов, нечетком изображении на экранах.
                            </li>
                            <li> Для тушения очага возгорания кабинет информатики должен быть обеспечен углекислотными огнетушителями.</li>
                        </ul>
                        <div style={{maxWidth:450,display: "inline-block", marginTop: 20, }}>
                            <img src={rectangle} alt="" />
                        </div>
                    </div>
                    <h2>Действия перед началом занятий.</h2>
                    <h3>УЧИТЕЛЬ ДОЛЖЕН:</h3>
                    <ul>
                        <li>Тщательно проветрить кабинет информатики и убедиться, что температура воздуха в кабинете находится в пределах 19..21 Соотносительная влажность воздуха - 55.... 62%.</li>
                        <li>Убедиться в наличии защитного заземления оборудования, а также защитных экранов видеотерминалов.</li>
                        <li>Включить видеотерминалы и проверить стабильность и четкость изображения на экранах.</li>
                    </ul>
                    <h3>УЧАЩИЙСЯ ДОЛЖЕН:</h3>
                    <ul>
                        <li>Занять рабочее место у персонального компьютера.</li>
                    </ul>
                    <h2>Действия учащихся при работе на персональном компьютере.</h2>
                    <ul>
                        <li>При работе на персональном компьютере учащийся должен точно выполнять указания учителя.</li>
                        <li>Во время работы учащемуся запрещается:</li>
                        - держать на рабочем месте предметы, не имеющие отношения к выполнению задания;<br />
                        - прикасаться руками к экрану монитора или снимать защитный фильтр;<br />
                        - перемещать компьютер по поверхности стола, а также переносить его отдельные элементы;<br />
                        - снимать кожухи компьютера, включённого в сеть;<br />
                        - включать питание при снятом кожухе видеомонитора, так как на электронно-лучевую трубку подаётся высокое напряжение;<br />
                        - самостоятельно выполнять переключение устройств (отключать клавиатуру, принтер, кабели видео-монитора), все переключения могут выполняться только при обесточенном оборудовании с разрешения преподавателя и в его присутствии;<br />
                        - размещать на клавиатуре литературу, вводимые тексты или другие учебные материалы;<br />
                        - во избежание перегрева закрывать жалюзи персонального компьютера предметами или бумагой;<br />
                        - самостоятельно устранять возникшие неисправности.<br />
                        <li>Учащемуся необходимо следить за тем, чтобы нажатие клавиши при работе на клавиатуре не носило характера сильного удара.</li>
                        <li>При пропадании питающего напряжения во время работы на персональном компьютере (гаснут светодиоды индикации питания на передней панели системного блока) необходимо выключить компьютер и сообщить о происшедшем учителю.</li>
                        <li>При работающем видеотерминале расстояние от глаз до экрана должно быть 0,6 .. 0.7м, уровень глаз должен приходиться на центр экрана или 2/3 его высоты.</li>
                        <li>Тетрадь для записей располагать на подставке с наклоном 12 .. 15 градусов на расстоянии 55 .. 65 см от глаз и должна быть хорошо освещена.</li>
                        <li>Изображение на экранах видеотерминалов должно быть стабильным, ясным и предельно четким, не иметь мерцаний символов и фона, на экранах не должно быть бликов и отражений светильников, окон и окружающих предметов.</li>
                        <li>Длительность работы с видеотерминалами не должна превышать для учащихся 1 классов (6 лет) - 10 мин, для учащихся 2-5 классов - 15 мин, 6-7 классов - 20 мин, 8-9 классов - 25 мин, 10 - 11 классов при двух уроках подряд на первом из них - 30 мин, на втором - 20 мин, после чего сделать перерыв не менее 10 мин для выполнения специальных упражнений, снимающих зрительное утомление.</li>
                    </ul>
                    <h2>Требования охраны труда в аварийных ситуациях.</h2>
                    <ul>
                        <li>В случае появления неисправности в работе видеотерминала выключить его и сообщить об этом учителю (преподавателю).</li>
                        <li>При плохом самочувствии, появлении головной боли, головокружения и др. прекратить работу и сообщить об этом учителю (препо&shy;давателю)</li>
                        <li>При поражении учащегося электрическим током немедленно отключить видеотерминалы, оказать первую помощь пострадавшему, со&shy;общить об этом администрации учреждения и родителям пострадавшего, при необходимости отправить его в ближайшее лечебное учреждение.</li>
                    </ul>
                    <h2>Действия учащихся после окончания работы на персональном компьютере.</h2>
                    <p>После окончания работы на персональном компьютере учащийся должен:</p>
                    <ul>
                        <li>Выключить персональный компьютер;</li>
                        <li>Привести своё рабочее место в порядок.</li>
                    </ul>
                </div>
            </Wrapper>
        </div>
    )
}

const mapStateToProps = (state) => ({

})

const mapDispatchToProps = {

}

export default connect(mapStateToProps, mapDispatchToProps)(Safety)
